"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedBlockCard = exports.BlockCardVariant = void 0;
var react_1 = __importDefault(require("react"));
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var block_video_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-video-75.svg"));
var block_text_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-text-75.svg"));
var block_image_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-image-75.svg"));
var block_embed_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-embed-75.svg"));
var block_quote_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-quote-75.svg"));
var block_accept_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-accept-75.svg"));
var block_agreement_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-agreement.svg"));
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var react_transition_group_1 = require("react-transition-group");
var SavedBlockMoreActionsMenu_1 = require("Dashboard/DashboardBlockLibrary/SavedBlockMoreActionsMenu/SavedBlockMoreActionsMenu");
var EditingRules_1 = require("SavedBlock/EditingRules");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var PlaceholderIcon_1 = require("SavedBlock/Utils/PlaceholderIcon");
var BlockCardVariant;
(function (BlockCardVariant) {
    BlockCardVariant["List"] = "list";
    BlockCardVariant["Card"] = "card";
})(BlockCardVariant || (exports.BlockCardVariant = BlockCardVariant = {}));
var ThumbnailLoadState;
(function (ThumbnailLoadState) {
    ThumbnailLoadState["NotLoaded"] = "notloaded";
    ThumbnailLoadState["Loaded"] = "loaded";
    ThumbnailLoadState["Failed"] = "failed";
})(ThumbnailLoadState || (ThumbnailLoadState = {}));
var SavedBlockCard = (function (_super) {
    __extends(SavedBlockCard, _super);
    function SavedBlockCard() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.isHovering = false;
        _this.isFocused = false;
        _this.thumbnailLoadState = ThumbnailLoadState.NotLoaded;
        _this.handleThumbnailLoaded = function (wasSuccessful) {
            _this.thumbnailLoadState = wasSuccessful ? ThumbnailLoadState.Loaded : ThumbnailLoadState.Failed;
        };
        _this.onCheckboxClick = function (key, event) {
            _this.props.toggleSelection(_this.props.blockId, event);
        };
        _this.handleBlockInnerClick = function (e) {
            if (_this.props.enableSelection) {
                e.stopPropagation();
            }
        };
        _this.setIsHovering = function (newValue) {
            _this.isHovering = newValue;
        };
        _this.setIsFocused = function (newValue) {
            _this.isFocused = newValue;
        };
        _this.handlePreviewClick = function (event) {
            event.stopPropagation();
            _this.props.onPreviewClick();
        };
        _this.handleClick = function (event) {
            event.stopPropagation();
            _this.props.onClick();
        };
        _this.handleEditClick = function (event) {
            event.stopPropagation();
            _this.props.onEditClick();
        };
        return _this;
    }
    SavedBlockCard.prototype.getThumbnailUrl = function () {
        return this.props.thumbnailUrl || null;
    };
    SavedBlockCard.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, editingIsLockedToAdmins = _a.editingIsLockedToAdmins, userIsAdmin = _a.userIsAdmin, createdAt = _a.createdAt, blockId = _a.blockId, onToggleEditingIsLockedToAdmins = _a.onToggleEditingIsLockedToAdmins, onDeleteClick = _a.onDeleteClick, blockType = _a.blockType, variant = _a.variant, isUsingThumbnails = _a.isUsingThumbnails, canEditQuoteV1 = _a.canEditQuoteV1;
        var isCardView = variant === BlockCardVariant.Card;
        var userHasEditingPermissions = !editingIsLockedToAdmins || userIsAdmin;
        var editStatus = (0, EditingRules_1.getSavedBlockEditStatus)(userHasEditingPermissions, canEditQuoteV1, blockType);
        var showActions = this.isHovering || this.isFocused;
        var renderPlaceholder = isCardView && this.thumbnailLoadState !== ThumbnailLoadState.Loaded;
        var loadingThumbnailAllowed = isUsingThumbnails;
        var renderThumbnail = isCardView && loadingThumbnailAllowed && this.thumbnailLoadState !== ThumbnailLoadState.Failed;
        var isLoadingThumbnail = isUsingThumbnails && this.thumbnailLoadState === ThumbnailLoadState.NotLoaded;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("saved-block-card__outer", "saved-block-card__outer--".concat(variant)), onMouseEnter: function () { return _this.setIsHovering(true); }, onMouseLeave: function () { return _this.setIsHovering(false); }, onMouseOver: function () { return _this.setIsHovering(true); }, onFocus: function () { return _this.setIsFocused(true); }, onBlur: function () { return _this.setIsFocused(false); } },
            react_1.default.createElement(kaleidoscope_1.ButtonCard, { className: (0, classnames_1.default)("saved-block-card", {
                    "saved-block-card--hovered": this.isHovering,
                    "saved-block-card--selected": this.props.isSelected,
                }), onClick: this.handleClick, isDraggable: true },
                react_1.default.createElement("div", null,
                    renderThumbnail && (react_1.default.createElement("img", { className: (0, classnames_1.default)("saved-block-card__thumbnail", {
                            "saved-block-card__thumbnail--loading": isLoadingThumbnail,
                        }), src: this.getThumbnailUrl(), onError: function () {
                            _this.handleThumbnailLoaded(false);
                        }, onLoad: function () {
                            _this.handleThumbnailLoaded(true);
                        }, alt: name })),
                    renderPlaceholder && (react_1.default.createElement("div", { className: "saved-block-card__placeholder" },
                        react_1.default.createElement("div", { className: "saved-block-card__placeholder-image" },
                            react_1.default.createElement(kaleidoscope_1.SVG, { src: this.savedBlockPlaceholder })),
                        react_1.default.createElement("div", { className: "saved-block-card__placeholder-text" }, "Preview loading"))),
                    react_1.default.createElement("div", { className: "saved-block-card__inner", onClick: this.handleBlockInnerClick },
                        this.props.enableSelection && (react_1.default.createElement(kaleidoscope_1.Checkbox, { item: { id: blockId, value: name, label: "" }, labelHidden: true, toggleKey: blockId, isSelected: this.props.isSelected, size: kaleidoscope_3.CheckboxSize.Medium, onChange: this.onCheckboxClick })),
                        react_1.default.createElement("div", { className: (0, classnames_1.default)("saved-block-card__metadata", {
                                "saved-block-card__metadata--resized": showActions,
                            }) },
                            !isCardView && react_1.default.createElement(kaleidoscope_1.SVG, { className: "saved-block-card__block-type", src: this.savedBlockIconSrc }),
                            react_1.default.createElement("div", { className: "saved-block-card__text" },
                                react_1.default.createElement("div", { className: "saved-block-card__name-wrapper" },
                                    editingIsLockedToAdmins && react_1.default.createElement(icons_1.Security, { className: "saved-block-card__locked" }),
                                    react_1.default.createElement("div", { className: "saved-block-card__name" }, name)),
                                !isCardView && (react_1.default.createElement("div", { className: "saved-block-card__last-edited" }, createdAt ? "Created On ".concat(createdAt) : ""))))))),
            react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: variant === BlockCardVariant.List, unmountOnExit: variant === BlockCardVariant.List, in: showActions, timeout: kaleidoscope_2.AnimationDuration.Short, classNames: "saved-block-card__actions-" },
                react_1.default.createElement("div", { key: "saved-block-card__actions", className: "saved-block-card__actions" },
                    react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Preview, { className: "saved-block-card__preview" }), onClick: this.handlePreviewClick, tooltip: { content: "Preview", position: kaleidoscope_1.TooltipPosition.Top } }),
                    react_1.default.createElement(kaleidoscope_1.IconButton, { disabled: !editStatus.canEdit, disabledReason: editStatus.noEditExplainer, icon: editStatus.canEdit ? react_1.default.createElement(icons_1.Edit, null) : react_1.default.createElement(icons_1.NoEdit, null), tooltip: {
                            content: "Edit",
                            position: kaleidoscope_1.TooltipPosition.Top,
                            size: userHasEditingPermissions ? undefined : kaleidoscope_1.TooltipSize.Large,
                        }, onClick: this.handleEditClick }),
                    react_1.default.createElement(SavedBlockMoreActionsMenu_1.SavedBlockMoreActionsMenu, { userIsAdmin: userIsAdmin, editingIsLockedToAdmins: editingIsLockedToAdmins, blockId: blockId, onToggleEditingIsLockedToAdmins: onToggleEditingIsLockedToAdmins, onDeleteClick: onDeleteClick })))));
    };
    Object.defineProperty(SavedBlockCard.prototype, "savedBlockIconSrc", {
        get: function () {
            switch (this.props.blockType) {
                case BlockTypes_1.BlockType.Text:
                    return block_text_75_svg_1.default;
                case BlockTypes_1.BlockType.Video:
                    return block_video_75_svg_1.default;
                case BlockTypes_1.BlockType.OldQuote:
                case BlockTypes_1.BlockType.Quote:
                    return block_quote_75_svg_1.default;
                case BlockTypes_1.BlockType.Accept:
                    return block_accept_75_svg_1.default;
                case BlockTypes_1.BlockType.Source:
                    return block_embed_75_svg_1.default;
                case BlockTypes_1.BlockType.Splash:
                    return block_image_75_svg_1.default;
                case BlockTypes_1.BlockType.Agreement:
                    return block_agreement_svg_1.default;
                case BlockTypes_1.BlockType.Browser:
                default:
                    return block_text_75_svg_1.default;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockCard.prototype, "savedBlockPlaceholder", {
        get: function () {
            return (0, PlaceholderIcon_1.getSavedBlockPlaceholderByType)(this.props.blockType);
        },
        enumerable: false,
        configurable: true
    });
    SavedBlockCard.defaultProps = {
        isSelected: false,
        enableSelection: false,
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SavedBlockCard.prototype, "isHovering", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SavedBlockCard.prototype, "isFocused", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], SavedBlockCard.prototype, "thumbnailLoadState", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockCard.prototype, "handleThumbnailLoaded", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockCard.prototype, "setIsHovering", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockCard.prototype, "setIsFocused", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockCard.prototype, "handlePreviewClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockCard.prototype, "handleClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockCard.prototype, "handleEditClick", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SavedBlockCard.prototype, "savedBlockIconSrc", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SavedBlockCard.prototype, "savedBlockPlaceholder", null);
    SavedBlockCard = __decorate([
        mobx_react_1.observer
    ], SavedBlockCard);
    return SavedBlockCard;
}(react_1.default.Component));
exports.SavedBlockCard = SavedBlockCard;
